/* eslint-disable */
import moment from 'moment';
import {
	useEffect,
	useMemo,
	useState
} from 'react';
import { connect } from 'react-redux';
// import { useHistory } from 'react-router';
import analyticsAction from '../../../../Actions/analytics.actions';
import { OutwardingImageResults } from '../../../../Components/Analytics/Outwarding';
import { DefectImageModal } from '../../../../Components/Modals';
import { liveQCServices } from '../../../../Services/LiveQC';
import styles from './OutwardingImagesPage.module.css';
import outwardingAnalyticsServices from '../../../../Services/Analytics Services/outwarding-analytics.services';
import ImagesFinder from '../../../../Components/ImagesFinder/ImagesFinder';
import { Button, Chip } from '@mui/material';
import { Filter } from 'lucide-react';
import drawerActions from '@/Actions/drawer.actions';
import { filtersInfoChip } from '@/Helpers';
import { SelectPicker } from 'rsuite';

// const source =
// 'https://www.thespruceeats.com/thmb/vJUFf6L4p8y9Cn_1pE9Z7Ua9uok=/3000x2001/filters:fill(auto,1)/indian-style-burger-1957599-hero-01-266103a4bb4e4ee7b5feb4da2d2e99da.jpg';

const FIND_FILTERS = ['store', 'processTypes', 'pageLimit', 'brand', 'product', 'dateRange'];

const OutwardingImagesPage = (props) => {
	const [filters, setFilters] = useState({
		store: null,
		processTypes: null,
		products: [],
		brand: null,
		identification: 'Both',
		dateRange: {
			active: false,
			from: new Date(),
			to: new Date(),
		},
	});

	const {
		updateOutwardingImagesById,
		allOutwardingResults,
		fetchOutwardingImages,
		resetOutwardingImages,
		toggleFiltersDrawer,
	} = props;

	useEffect(() => {
		resetOutwardingImages();
	}, []);

	const [pageLimit, setPageLimit] = useState(6);

	const submitFindRequest = ({
		store = null,
		processTypes = null,
		products = [],
		dateRange = {},
		brand = null,
		skuType = null,
	}) => {
		resetOutwardingImages();
		setFilters({
			store,
			processTypes,
			products,
			dateRange,
			brand,
			skuType,
		});
		const data = {
			storeId: store?.id,
			processTypes: processTypes?.id,
			products: products?.id,
			brandId: brand?.id,
			skuType: skuType?.toUpperCase(),
			dateRangeFilter: dateRange?.active
				? {
					from: moment(dateRange?.from).format('YYYY-MM-DD'),
					to: moment(dateRange?.to).format('YYYY-MM-DD'),
				}
				: {},
		};
		fetchOutwardingImages({
			entity: 'OUTWARDING_ANALYSIS',
			method: 'FIND_OUTWARDING_IMAGES',
			req: {
				data,
				params: {
					limit: pageLimit,
				},
			},
		});
	};

	const fetchWastageImagesById = async ({ pageNo, productId }, index) => {
		const response =
			await outwardingAnalyticsServices.fetchOutwardingImagesById({
				params: {
					page: pageNo,
					limit: pageLimit,
				},
				data: {
					storeId: filters?.store?.id,
					processTypes: filters?.processTypes?.id,
					brandId: filters?.brand?.id,
					identification: filters?.identification,
					productId,
					dateRangeFilter: filters?.dateRange?.active
						? {
							from: moment(filters?.dateRange?.from).format(
								'YYYY-MM-DD'
							),
							to: moment(filters?.dateRange?.to).format(
								'YYYY-MM-DD'
							),
						}
						: {},
				},
			});

		const { data = [] } = response;
		updateOutwardingImagesById(index, data);
		return data;
	};

	const fetchQCData = async (qcId) => {
		try {
			const req = {
				params: {
					qcId,
				},
			};

			const { data = null } = await liveQCServices.getPastData(req);

			return data;
		} catch {
			return null;
		}
	};

	const totalValues = useMemo(() => {
		let totalShown = 0;
		let typeOfProducts = 0;
		let totalCount = 0;
		allOutwardingResults?.forEach((product) => {
			if (product?.Annotation.length > 0) {
				totalShown += product?.Annotation?.length ?? 0;
				typeOfProducts++;
			}
			totalCount += product?.count ?? 0;
		});
		return {
			totalShown,
			totalCount,
			typeOfProducts,
		};
	}, [allOutwardingResults]);

	const filtersInfo = {
		header: {
			product: false,
			store: false,
			date: false,
			process: false,
		},
		store: {
			text: 'Store',
			show: true,
		},
		processType: {
			text: 'Process Types',
			show: true,
		},
		dateRange: {
			text: 'Date Range',
			show: true,
		},
		skuType: {
			text: 'SKU Type',
			show: true,
		},
		product: {
			text: 'Product',
			show: true,
		},
	};

	const exportInfo = {
		hideExportAccordian : true,
	};

	return (
		<div className={styles.root}>
			<DefectImageModal />
			<ImagesFinder
				onSubmit={submitFindRequest}
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
			/>
			<div className='flex justify-between p-2 items-center'>	
				<span className='font-bold text-[16px]'>App Outwarding Images</span>
				<Button
					onClick={() => {
						toggleFiltersDrawer(true);
					}}
					className='flex items-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					Filter
					<Filter className='size-4' />
				</Button>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<div className='flex items-center gap-2'>
				<span>
					Page Limit : 
				</span>
				<SelectPicker
					data={[6, 25, 50, 100].map((item) => ({
						label: item,
						value: item,
					}))}
					value={pageLimit}
					onChange={(value) => setPageLimit(value)}
					searchable={false}
					className='w-[200px]'
				/>
			</div>
			{allOutwardingResults?.length !== 0 && (
				<div className={styles.numbers}>
					<div className={styles.element}>
						Total Count:
						<span>{totalValues?.totalCount}</span>
					</div>
					{/* <div className={styles.element}>
						Total Showing
						<span>{totalValues?.totalShown}</span>
					</div> */}
					<div className={styles.element}>
						Type of Products:
						<span>{totalValues?.typeOfProducts}</span>
					</div>
				</div>
			)}
			<div className={styles['image-results']}>
				{allOutwardingResults?.map((product, index) => {
					return (
						product.Annotation.length > 0 && (
							<OutwardingImageResults
								key={product?.id}
								showLoadMore={false}
								fetchImagesById={(req) => {
									fetchWastageImagesById(req, index);
								}}
								product={product}
								clickable
								fetchQCData={fetchQCData}
							/>
						)
					);
				})}
				{allOutwardingResults?.length === 0 && (
					<p className={styles.fallback}>No items to display</p>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { FIND_OUTWARDING_IMAGES: allOutwardingResults } =
		state.analytics.OUTWARDING_ANALYSIS;

	return {
		allOutwardingResults,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchOutwardingImages: (...args) => {
			dispatch(analyticsAction.gateway(...args));
		},
		// eslint-disable-next-line no-unused-vars
		updateOutwardingImagesById: (...args) => {
			dispatch(analyticsAction.updateOutwardingImagesList(...args));
		},
		resetOutwardingImages: () => {
			dispatch(analyticsAction.resetOutwardingImages());
		},
		toggleFiltersDrawer: (...args) => {
			dispatch(drawerActions.toggleFiltersDrawer(...args));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(OutwardingImagesPage);
